import { CellInput } from "@maxhub/max-ui"

export const CellInputExample = {
  title: "CellInput",
  defaultPlatform: "ios",
  defaultZoom: 100,

  controls: [
    {
      name: "before",
      label: "before",
      type: "text",
      tsType: "ReactNode",
      default: "First name",
    },
    {
      name: "height",
      label: "height",
      type: "enum",
      tsType: ['"compact"', '"normal"'],
      default: "normal",
      options: ["compact", "normal"],
    },
    {
      name: "placeholder",
      label: "placeholder",
      type: "text",
      tsType: "string",
      default: "Иван Иванов",
    },
    {
      name: "disabled",
      label: "disabled",
      type: "boolean",
      tsType: "boolean",
      default: false,
    },
    {
      name: "innerClassNames",
      label: "innerClassNames",
      type: "static",
      tsType: "InnerClassNamesProp<CellInputElementKey>",
      value: "-",
    },
  ],

  Preview({ props }) {
    return (
      <CellInput
        before={props.before}
        height={props.height}
        placeholder={props.placeholder}
        disabled={props.disabled}
      />
    )
  },

  getCode(props) {
    const lines = []
    lines.push(`  before="${props.before}"`)
    if (props.height !== "normal") lines.push(`  height="${props.height}"`)
    if (props.placeholder !== "Иван Иванов")
      lines.push(`  placeholder="${props.placeholder}"`)
    if (props.disabled) lines.push(`  disabled`)

    const propsStr = "\n" + lines.join("\n") + "\n"
    return `<CellInput${propsStr}/>`
  },
}